import {createAsyncThunk} from '@reduxjs/toolkit';
import announcementService from 'api/announcementService';

export const getAnnouncements = createAsyncThunk(
  'announcement/getAnnouncements',
  async (query, { rejectWithValue }) => {
    try {
      return await announcementService.getAnnouncements();
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
